import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosOrdenTrabajoEnumChoice,
  ROUTER_PATHS,
  useCheckPermissions,
  useLoaders,
} from '@/shared';
import { useGetOrdenTrabajo } from '@/shared/actions/erp';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { SaveOperacionTenicoPreRechazado } from '../../shared';

const returnUrlOperacionTecnicoPage =
  ROUTER_PATHS.operaciones.tecnicosInstalacionNav;
export type OperacionReviewOTInstallPRerechazadaProps = {};

const OperacionReviewOTInstallPRerechazada: React.FC<
  OperacionReviewOTInstallPRerechazadaProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_ordentrabajo);

  const navigate = useNavigate();

  const setAlert = useUiStore(s => s.setAlert);

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOrdenTrabajo(id!);
  useLoaders(isLoading || isRefetching);

  // validate state
  useEffect(() => {
    if (!data?.data?.id_orden_trabajo) return;
    if (
      data?.data?.estado_orden_trabajo !==
      EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO
    ) {
      setAlert(
        true,
        'La orden de trabajo no tiene el estado correcto',
        AlertSeverityEnum.error
      );
      navigate(returnUrlOperacionTecnicoPage);
    }
  }, [data?.data?.id_orden_trabajo]);

  if (isLoading || isRefetching) return null;
  if (!data?.data?.id_orden_trabajo)
    return <Navigate to={returnUrlOperacionTecnicoPage} />;

  return (
    <SaveOperacionTenicoPreRechazado
      titlePage="Revisión de Instalación Pre-Rechazada"
      ordenTrabajo={data.data}
    />
  );
};

export default OperacionReviewOTInstallPRerechazada;
